module.exports = __webpack_public_path__ + "media/images/home/logo-clutter-endorser-footer-51f62557b149b5b57ca66556615f8d29.png";